import Table from 'react-bootstrap/Table';
import { useTable, useSortBy } from 'react-table';
import { useMemo } from 'react';
import Button from 'react-bootstrap/Button';

function AdminOrganizerTable({
  organizerList,
  onActivate,
  onInactivate,
  chosenOrganizerId,
  chosenOrganizer,
  onEdit,
}) {
  const data = useMemo(() => organizerList, [organizerList]);

  const columns = useMemo(
    () => [
      {
        Header: 'Klubb',
        accessor: 'clubName',
        className: 'p-3',
        style: { width: '25%' },
        Cell: ({ cell: { value } }) => (
          <div className='d-flex gap-1'>
            <b>{value ? value : 'Ej angett'}</b>
          </div>
        ),
      },
      {
        Header: 'Klubbadministratör',
        accessor: 'email',
        className: 'p-3',
        style: { width: '25%' },
        Cell: ({ cell: { value } }) => (
          <div className='d-flex gap-1'>{value ? value : 'Ej angett'}</div>
        ),
      },
      {
        Header: 'Organisationsnummer',
        accessor: 'organizationNumber',
        className: 'p-3',
        style: { width: '15%' },
        Cell: ({ cell: { value } }) => (
          <div className='d-flex gap-1'>{value ? value : 'Ej angett'}</div>
        ),
      },
      {
        Header: 'Distrikt',
        accessor: 'district',
        className: 'p-3',
        style: { width: '25%' },
        Cell: ({ cell: { value } }) => (
          <div className='d-flex gap-1'>{value ? value : 'Ej angett'}</div>
        ),
      },
      {
        Header: '',
        accessor: 'activate/inactivate',
        className: 'p-3',
        Cell: (props) => (
          <>
            {props.row.original.isActive ? (
              <div
                className='d-flex gap-2 justify-content-end always-active'
                role='button'
                onClick={() => {
                  chosenOrganizerId(props.row.original.id);
                  onInactivate();
                }}
              >
                <span className='material-symbols-outlined'>
                  do_not_disturb_on
                </span>
                <span>Inaktivera</span>
              </div>
            ) : (
              <div
                className='d-flex gap-2 justify-content-end always-active'
                role='button'
                onClick={() => {
                  chosenOrganizerId(props.row.original.id);
                  onActivate();
                }}
              >
                <span className='material-symbols-outlined'>add_circle</span>
                <span>Aktivera</span>
              </div>
            )}
          </>
        ),
      },
      {
        Header: '',
        accessor: 'edit',
        className: 'p-3 d-flex justify-content-end',
        Cell: (props) => (
          <Button
            variant='outline-primary'
            className='py-0 px-3'
            disabled={!props.row.original.isActive}
            onClick={() => {
              chosenOrganizer(props.row.original);
              onEdit();
            }}
          >
            Redigera
          </Button>
        ),
      },
    ],
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns,
        data,
      },
      useSortBy
    );

  return (
    <Table
      {...getTableProps()}
      style={{
        borderCollapse: 'separate',
        borderSpacing: '0 0.5rem',
        width: '100%',
      }}
      className='table-borderless'
    >
      <thead className='bg-divider'>
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => (
              <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                {column.render('Header')}
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row) => {
          prepareRow(row);
          return (
            <tr
              {...row.getRowProps()}
              className={
                row.original.isActive ? 'bg-white' : 'bg-white inactive-tr'
              }
              style={{ borderStyle: 'none' }}
            >
              {row.cells.map((cell) => {
                return (
                  <td
                    {...cell.getCellProps()}
                    className={cell.column.className}
                    style={cell.column.style}
                  >
                    {cell.render('Cell')}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
}

export default AdminOrganizerTable;
